const vorgangsart = [
	"Ausgrabung",
	"Bauarchaeologische Untersuchung",
	"Baubegleitung",
	"Beobachtung / Aufsammlung",
	"Fotodokumentation",
	"Notbergung",
	"Oberbodenabtrag",
	"Prospektion - Begehung",
	"Prospektion - Einzelfundeinmessung",
	"Prospektion - Geoarchaeologische Bohrungen",
	"Prospektion - geoarchaeologische Sondagen",
	"Prospektion - Geophysik (Elektrik)",
	"Prospektion - Geophysik (Magnetik)",
	"Prospektion - Geophysik (Sonstiges)",
	"Prospektion - LIDAR",
	"Prospektion - Luftbild",
	"Prospektion - Metalldetektorsuche",
	"Prospektion - Sondagen",
	"Tauchgrabung",
	"topografische Aufnahme",
	"unbekannt",
	"3D Aufnahme"
];

export default vorgangsart;
